import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import './leftLabeledTextField.scss';
import { primaryBlue, textColorGray } from '../../../../../theme/mainColors';

class LeftLabelTextField extends React.PureComponent {
  state = {
    touched: false
  };

  handleTextFieldChange = (event, value) => this.props.profilesActions.updateProfileField(value);

  handleOnBlur = () => {
    this.setState({ touched: true });
    this.props.profilesActions.blurProfileField();
  };

  render() {
    const { label, value, required, name, style, textFieldStyle, pristineForm } = this.props;
    return  (
      <div className="left-label-text-field" style={ style }>
        <label htmlFor={ name }>{ label }</label>
        <TextField
          name={ name }
          value={ value }
          onChange={ this.handleTextFieldChange }
          underlineStyle={ { borderColor: textColorGray} }
          underlineFocusStyle={ { borderColor: primaryBlue } }
          onBlur={ this.handleOnBlur }
          required={ required }
          errorText={ (required && !value && this.state.touched && !pristineForm)? 'This field is required' : '' }
          style={ textFieldStyle }
        />
      </div>
    );
  }
}

LeftLabelTextField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string.isRequired,
  style: PropTypes.object,
  textFieldStyle: PropTypes.object,
  pristineForm: PropTypes.bool,
  profilesActions: PropTypes.shape({
    updateProfileField: PropTypes.func,
    blurProfileField: PropTypes.func
  }).isRequired
};

LeftLabelTextField.defaultProps = {
  required: false,
  textFieldStyle: {},
  pristineForm: true,
  style: {}
};

export default LeftLabelTextField;



// WEBPACK FOOTER //
// ./src/shared/components/connectedTextField/c/leftLabeledTextField/LeftLabelTextField.js